exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-messages-tickets-components .chat-container{margin-bottom:1.4rem}", ""]);

// exports
